var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGgng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GGNG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 4H21.3333C22.8 4 24 5.2 24 6.66667V20H21.3333V6.66667H2.66667V20H0V6.66667C0 5.2 1.2 4 2.66667 4ZM9.3335 9.33334H6.66659V7.46205H5.33325V9.33334H3.48387V10.6667H5.33325V13.3333H3.48387V14.6666H5.33325V17.3333H3.48387V18.6666H5.33325V20H6.66659V18.6666H9.3335V20H10.6668V18.6666H13.3335V20H14.6668V18.6666H17.3333V20H18.6666V18.6666H20.5301V17.3333H18.6666V14.6666H20.5301V13.3333H18.6666V10.6667H20.5301V9.33334H18.6666V7.46205H17.3333V9.33334H14.6668V7.46205H13.3335V9.33334H10.6668V7.46205H9.3335V9.33334ZM17.3333 10.6667H14.6668V13.3333H17.3333V10.6667ZM17.3333 14.6666H14.6668V17.3333H17.3333V14.6666ZM13.3335 14.6666V17.3333H10.6668V14.6666H13.3335ZM13.3335 10.6667V13.3333H10.6668V10.6667H13.3335ZM9.3335 10.6667H6.66659V13.3333H9.3335V10.6667ZM9.3335 14.6666H6.66659V17.3333H9.3335V14.6666Z",
    fill: "#797979"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgng);
export default __webpack_public_path__ + "static/media/ggng.c71eac6f763da3ee1e057a33490f47ad.svg";
export { ForwardRef as ReactComponent };